import { render, staticRenderFns } from "./ItemDetailLicenseLayout.vue?vue&type=template&id=0fd1b1eb&scoped=true"
import script from "./ItemDetailLicenseLayout.vue?vue&type=script&lang=js"
export * from "./ItemDetailLicenseLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1b1eb",
  null
  
)

export default component.exports